<template>
  <main>
    <section
      v-if="!isDisable"
      class="molecule-checkbox-threshold_container"
      :class="[isSelect ? 'checkbox--active' : 'checkbox--unactive', {'checkbox--enable': canUpdate}]"
      @click="toggleActive"
    >
      <div class="row">
        <div
          class="col-6"
          :class="[isSelect ? 'text--warning-color' : 'text--normal-color']"
        >
          <div class="text--topic">Warning</div>
          <div class="text--value">
            {{ warningValueComputed }}
          </div>
        </div>
        <div
          class="col-6"
          :class="[isSelect ? 'text--critical-color' : 'text--normal-color']"
        >
          <div class="text--topic">Critical</div>
          <div class="text--value">
            {{ criticalValueComputed }}
          </div>
        </div>
      </div>
      <transition name="fade">
        <div v-if="isSelect" class="checkbox">
          <feather-icon icon="CheckIcon" stroke="#FFFFFF"></feather-icon>
        </div>
      </transition>
    </section>

    <section
      v-else
      class="molecule-checkbox-threshold_container checkbox--disable"
    >
      <div class="row">
        <div class="col-6 text--normal-color">
          <div class="text--topic">Warning</div>
          <div class="text--value">
            {{ warningValueComputed }}
          </div>
        </div>
        <div class="col-6 text--normal-color">
          <div class="text--topic">Critical</div>
          <div class="text--value">
            {{ criticalValueComputed }}
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  name: "MoleculeCheckboxThreshold",
  props: {
    warningValue: {
      type: [Number, String],
      required: false,
      default: null,
    },
    criticalValue: {
      type: [Number, String],
      required: false,
      default: null,
    },
    isDisable: {
      type: Boolean,
      required: false,
      default: false,
    },
    value: {
      type: Boolean,
      required: false,
      default: false,
    },
    canUpdate: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    isSelect: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit("input", value)
      },
    },
    warningValueComputed() {
      if (this.warningValue === null) {
        return "-"
      }
      return this.warningValue
    },
    criticalValueComputed() {
      if (this.criticalValue === null) {
        return "-"
      }
      return this.criticalValue
    },
  },
  methods: {
    toggleActive() {
      if (this.canUpdate) this.isSelect = !this.isSelect
    },
  },
}
</script>

<style lang="scss" scoped>
.molecule-checkbox-threshold_container {
  position: relative;
  border-radius: 4px;
  padding: 3px 10px;
  width: 120px;
}

.checkbox--active {
  background: #ffffff;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
}

.checkbox--unactive {
  background: #ffffff;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.15);
}

.checkbox--enable {
  &:hover {
    cursor: pointer;
  }
}

.checkbox--disable {
  background: #efefef;
}

.text--topic {
  font-weight: 400;
  font-size: 8px;
}

.text--value {
  font-weight: 400;
  font-size: 12px;
}

.text--normal-color {
  color: #b9b9c3;
}

.text--critical-color {
  transition: color 0.25s linear;
  color: #dc483c;
}

.text--warning-color {
  transition: color 0.25s linear;
  color: #ff9f43;
}

.checkbox {
  padding: 2px;
  background: #7367f0;
  display: flex;
  border-radius: 50%;
  position: absolute;
  top: -8px;
  right: -8px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s;
}

// Small devices (landscape phones, 576px and up)
@media screen and (min-width: 576px) {
}

// Medium devices (tablets, 768px and up)
@media screen and (min-width: 768px) {
  
}

// Large devices (desktops, 992px and up)
@media screen and (min-width: 992px) {
 
}

// X-Large devices (large desktops, 1200px and up)
@media screen and (min-width: 1200px) {
 
}
</style>
